// src/components/library/BookCard.js
import React from 'react';
import { decrypt } from '../../utils/security';

// Exact gradients from HTML CSS
const GRADIENTS = [
  'linear-gradient(150deg,#D4A5A3,#C08A88)', // rose - IPC
  'linear-gradient(150deg,#A3B4CC,#8898B8)', // slate - CrPC
  'linear-gradient(150deg,#A3C4B4,#88AE9E)', // sage - Evidence
  'linear-gradient(150deg,#C4B488,#AE9E74)', // sand - Constitution
  'linear-gradient(150deg,#B4A3C8,#9E88B4)', // lavender - CPC
  'linear-gradient(150deg,#C4A3B4,#AE8E9E)', // rose-lavender - Arb
  'linear-gradient(150deg,#C4B4A3,#AE9E8E)', // warm tan - Bare
  'linear-gradient(150deg,#B4B4A8,#9E9E94)', // grey - Archive
  'linear-gradient(150deg,#A8B8C8,#9098B0)', // blue-grey
  'linear-gradient(150deg,#C8A8A8,#B09090)', // muted rose
];

const BookCard = ({ book, onClick, isBookmarked, progress = 0, animDelay = 0, size = 'md' }) => {
  const encryptedTitle = book.book_name || book.book_title || book.title || '—';
  const title = decrypt(encryptedTitle);
  const idx   = (book._id || book.id || 0) % GRADIENTS.length;
  const grad  = GRADIENTS[Math.abs(idx)];

  const width = 120;
  const height = 160;

  return (
    <div className="flex-shrink-0 cursor-pointer group" style={{ animationDelay:`${animDelay}s` }}
      onClick={onClick}>
      {/* Cover */}
      <div className="relative rounded-lg overflow-hidden shadow-sm group-hover:shadow-md group-hover:-translate-y-1 transition-all duration-300"
        style={{ background: grad, width, height }}>
        {/* Spine shadow for premium 3D book depth */}
        <div className="absolute left-0 top-0 bottom-0 w-1.5" style={{ background:'linear-gradient(90deg, rgba(0,0,0,0.15), transparent)' }}/>
        <div className="absolute left-1.5 top-0 bottom-0 w-0.5" style={{ background:'rgba(255,255,255,.15)' }}/>
        
        {/* Gradient overlay for contrast and legibility */}
        <div className="absolute inset-0 flex flex-col justify-end"
          style={{ padding:'12px', background:'linear-gradient(transparent 30%, rgba(0,0,0,0.55))' }}>
          <div className="font-ui font-semibold text-white leading-snug"
            style={{ fontSize:10.5, fontFamily:'Nunito,sans-serif', textShadow:'1px 1px 2px rgba(0,0,0,0.4)' }}>
            {title.length > 45 ? title.substring(0, 45) + '…' : title}
          </div>
        </div>
        
        {/* NEW badge */}
        {book.badge === 'NEW' && (
          <div className="absolute top-2 right-2 text-white text-[8px] font-bold px-1.5 py-0.5 rounded-sm"
            style={{ background:'var(--rose)', fontFamily:'Nunito,sans-serif' }}>NEW</div>
        )}
        {/* ARCHIVE badge */}
        {book.badge === 'ARCHIVE' && (
          <div className="absolute top-2 right-2 text-white text-[8px] font-bold px-1.5 py-0.5 rounded-sm"
            style={{ background:'var(--sand)', fontFamily:'Nunito,sans-serif' }}>ARCHIVE</div>
        )}
        {/* Bookmark star */}
        {isBookmarked && (
          <div className="absolute top-2 left-2 text-white text-xs" style={{ textShadow:'1px 1px 2px rgba(0,0,0,0.4)' }}>★</div>
        )}
        {/* Progress bar */}
        {progress > 0 && (
          <div className="absolute bottom-0 left-0 right-0 h-1" style={{ background:'rgba(0,0,0,.2)' }}>
            <div className="h-full" style={{ width:`${progress}%`, background:'var(--rose)' }}/>
          </div>
        )}
      </div>
      {/* Label under cover */}
      <div className="mt-2" style={{ width }}>
        <div className="font-ui font-semibold text-ink-mid leading-snug line-clamp-2 group-hover:text-rose transition-colors"
          style={{ fontSize:11, fontFamily:'Nunito,sans-serif' }}>
          {title}
        </div>
      </div>
    </div>
  );
};

export default BookCard;